import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import media from 'src/styles/media';

import imgClose from 'src/assets/images/triangle-close.svg';
import imgOpen from 'src/assets/images/triangle-down.svg';

const Category = ({ category, index, handleCategory, shown }) => (
  <Root shown={shown}>
    <Title onClick={() => handleCategory(index)} shown={shown}>
      <h3>{category.title}</h3>{' '}
      {shown ? (
        <img src={imgOpen} alt="Category Open" />
      ) : (
        <img src={imgClose} alt="Category Close" />
      )}
    </Title>
    <Points shown={shown}>
      {category.points.map((point, index) => (
        <p key={index}>
          {index + 1}. {point.name}
        </p>
      ))}
    </Points>
  </Root>
);

export default Category;

Category.propTypes = {
  category: PropTypes.object,
  index: PropTypes.number,
  handleCategory: PropTypes.func,
  shown: PropTypes.bool,
};

const Root = styled.div`
  background-color: ${props =>
    props.shown ? '#0B1A27' : 'rgba(255, 255, 255, 0.2)'};
  border-bottom: 1px solid ${({ theme }) => theme.colorDarkBlue};
`;

const Title = styled.div`
  color: white;
  padding: 15px 30px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  h3 {
    text-transform: uppercase;
    font-family: ${({ theme }) => theme.fontHeader};
    font-weight: 400;
  }
`;

const Points = styled.div`
  max-height: ${props => (props.shown ? '500px' : '0px')};
  transition: 0.5s ease-in-out;
  overflow-y: ${props => (props.shown ? 'scroll' : 'hidden')};
  color: white;
  padding: 0px 30px;
  ::-webkit-scrollbar {
    width: 7px;
  }
  ::-webkit-scrollbar-thumb {
    display: none;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    @media (min-width: ${media.smup}) {
      display: block;
    }
  }
  @media (min-width: ${media.mdup}) {
    max-height: ${props => (props.shown ? '130px' : '0px')};
  }
  @media (min-width: ${media.lgup}) {
    max-height: ${props => (props.shown ? '175px' : '0px')};
  }
  p {
    margin-bottom: 7px;
    font-family: ${({ theme }) => theme.fontMain};
    font-size: 18px;
    line-height: 24px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Map/elements/Category.js